/**
 * Agent Configuration
 * Configuration constants for agent types with emojis and display info
 */

import type { AgentType } from '../../types'

export interface AgentTypeInfo {
  emoji: string
  name: string
  description: string
  color: string
}

/**
 * Configuration for each agent type with display information
 */
export const AGENT_TYPE_CONFIG: Record<AgentType, AgentTypeInfo> = {
  Alex: {
    emoji: '👨‍💼',
    name: 'Alex',
    description: 'Business Analyst',
    color: '#3B82F6',
  },
  Scarlet: {
    emoji: '👩‍💻',
    name: 'Scarlet',
    description: 'Technical Writer',
    color: '#EF4444',
  },
  Sia: {
    emoji: '👩‍🎨',
    name: 'Sia',
    description: 'Creative Director',
    color: '#8B5CF6',
  },
  Olga: {
    emoji: '👩‍🔬',
    name: 'Olga',
    description: 'Data Scientist',
    color: '#10B981',
  },
  Dimi: {
    emoji: '👨‍💻',
    name: 'Dimi',
    description: 'Developer',
    color: '#F59E0B',
  },
  Andrew: {
    emoji: '👨‍🏫',
    name: 'Andrew',
    description: 'Educator',
    color: '#EC4899',
  },
}

/**
 * Get agent type info by type
 */
export function getAgentTypeInfo(agentType: AgentType): AgentTypeInfo {
  return AGENT_TYPE_CONFIG[agentType]
}

/**
 * Get all agent types
 */
export function getAllAgentTypes(): AgentType[] {
  return Object.keys(AGENT_TYPE_CONFIG) as AgentType[]
}
